module.exports = __webpack_public_path__ + "static/media/logo.b135463b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/logo.png
// module id = 774
// module chunks = 1 3